var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EgressServiceError, EgressUnexpectedResponseError, FetchError, OCSError, TimeoutError, } from "./errorTypes";
var knownErrorTypes;
(function (knownErrorTypes) {
    knownErrorTypes["fetchError"] = "fetchError";
    knownErrorTypes["egressServiceError"] = "egressServiceError";
    knownErrorTypes["egressUnexpectedResponseError"] = "egressUnexpectedResponseError";
    knownErrorTypes["timeoutError"] = "timeoutError";
    knownErrorTypes["ocsError"] = "ocsError";
})(knownErrorTypes || (knownErrorTypes = {}));
function getErrorType(e) {
    if (e instanceof FetchError)
        return knownErrorTypes.fetchError;
    if (e instanceof EgressServiceError)
        return knownErrorTypes.egressServiceError;
    if (e instanceof EgressUnexpectedResponseError)
        return knownErrorTypes.egressUnexpectedResponseError;
    if (e instanceof TimeoutError)
        return knownErrorTypes.timeoutError;
    if (e instanceof OCSError)
        return knownErrorTypes.ocsError;
    return undefined;
}
export function isEncodedError(u) {
    if (!u || typeof u !== 'object')
        return false;
    var o = u;
    if (!('message' in o))
        return false;
    if (typeof o.message !== 'string')
        return false;
    if ('errorType' in o && typeof o.errorType !== 'string')
        return false;
    if (!('props' in o))
        return false;
    if (!o.props)
        return false;
    if (typeof o.props !== 'object')
        return false;
    return true;
}
function isEncodedFetchError(u) {
    if (!isEncodedError(u))
        return false;
    var se = u;
    if (se.errorType != knownErrorTypes.fetchError)
        return false;
    if (!('status' in se.props))
        return false;
    if (typeof se.props.status !== 'number')
        return false;
    return true;
}
function isEncodedEgressServiceError(u) {
    if (!isEncodedError(u))
        return false;
    var se = u;
    if (se.errorType != knownErrorTypes.egressServiceError)
        return false;
    if (!('errorCode' in se.props))
        return false;
    if (typeof se.props.errorCode !== 'string')
        return false;
    return true;
}
function isEncodedEgressUnexpectedResponseError(u) {
    if (!isEncodedError(u))
        return false;
    var se = u;
    if (se.errorType != knownErrorTypes.egressUnexpectedResponseError)
        return false;
    if (!('httpStatusCode' in se.props))
        return false;
    if (typeof se.props.httpStatusCode !== 'number')
        return false;
    return true;
}
function isEncodedTimeoutError(u) {
    if (!isEncodedError(u))
        return false;
    var se = u;
    if (se.errorType != knownErrorTypes.timeoutError)
        return false;
    return true;
}
function isEncodedOCSError(u) {
    if (!isEncodedError(u))
        return false;
    var se = u;
    if (se.errorType != knownErrorTypes.ocsError)
        return false;
    if (!('error' in se.props))
        return false;
    if (typeof se.props.error !== 'string')
        return false;
    return true;
}
function decodeGenericError(e) {
    var error = new Error(e.message);
    Object.assign(error, e.props);
    return error;
}
function decodeFetchError(e) {
    return new FetchError(e.message, e.props.status, e.props.responseData, e.props.responseHeaders, e.props.axiosErrorCode, e.props.errorTranslationKey);
}
function decodeEgressServiceError(e) {
    return new EgressServiceError(e.props.errorCode, e.message);
}
function decodeEgressUnexpectedResponseError(e) {
    return new EgressUnexpectedResponseError(e.props.httpStatusCode, e.message);
}
function decodeTimeoutError(e) {
    return new TimeoutError(e.message);
}
function decodeOCSError(e) {
    return new OCSError(e.message, e.props.error);
}
export function encodeError(e) {
    return {
        message: e.message,
        props: __assign({}, e),
        errorType: getErrorType(e),
    };
}
export function decodeError(e) {
    if (!isEncodedError(e))
        throw new Error('not a valid encoded error');
    if (isEncodedFetchError(e))
        return decodeFetchError(e);
    if (isEncodedEgressServiceError(e))
        return decodeEgressServiceError(e);
    if (isEncodedEgressUnexpectedResponseError(e))
        return decodeEgressUnexpectedResponseError(e);
    if (isEncodedTimeoutError(e))
        return decodeTimeoutError(e);
    if (isEncodedOCSError(e))
        return decodeOCSError(e);
    return decodeGenericError(e);
}
//# sourceMappingURL=encoder.js.map